module.exports = __webpack_public_path__ + "static/media/fal_fal_tre_pla.5a1850ec.png";